import React, { Component } from 'react';
import { Form } from 'react-bootstrap';
import { StopsListDataIdentifierCommonForm } from './StopsListDataIdentifierCommonForm';

export class HorizontalStopsListDataIdentifier extends Component {
    constructor(props) {
        super(props);

        const defaultConfig = {
            showOnlyInSpineStops: false,
            hideNonInSpineStops: false,
            hidePreviousStops: false,
            hideZoneLimitStops: false,
            hideStopsWithMapPoint: false,
            shrinkText: false,
            showStopCaps: false,
            showStopCode: false,
            stopCodePrecendentText: "",
            stopCodeSubsequentText: "",
            showDurations: true,
            durationBackgroundBuilderComponent: 0,
            zoneTextRotationAngle: 0,
            imageOrientation: "left",
            imageId: null,
            showInterfacesInSpine: true,
            interfaceOption: undefined,
            interfaceRotationAngle: undefined,
            interfaceResizeFactor: undefined,
            showPathsDescription: false,
            addSpacerStops: false,
            highlightComplementaryTerminals: false,
            stretchSpine: false,
            showDescriptionOutsideSpine: false,
            descriptionOutsideSpine: "",
            zonesConfig: {
                zonesPosition: "left",
                zones: [],
                zonesBackgroundBuilderComponent: 0
            }
        };

        const parseSelectedData = (selectedDataStr) => {
            try {
                const [rotation, configStr] = selectedDataStr.split('|%|');
                const parsed = JSON.parse(configStr);

                const config = parsed.zonesConfig && Object.keys(parsed).length === 1
                    ? { ...defaultConfig, zonesConfig: { ...defaultConfig.zonesConfig, ...parsed.zonesConfig } }
                    : { ...defaultConfig, ...parsed };

                return {
                    textRotationAngle: rotation || "90",
                    ...config
                };
            } catch (e) {
                return {
                    textRotationAngle: "90",
                    ...defaultConfig
                };
            }
        };

        const formData = props.selectedData ? parseSelectedData(props.selectedData) : { textRotationAngle: "90", ...defaultConfig };

        this.state = {
            form: formData,
            styles: {
                textRotationAngle: null
            }
        };
    }

    // --------------------

    setNestedValue(obj, path, value) {
        const parts = path.split(".");
        let current = obj;
        for (let i = 0; i < parts.length - 1; i++) {
            if (!current[parts[i]]) current[parts[i]] = {};
            current = current[parts[i]];
        }
        current[parts[parts.length - 1]] = value;
    }

    // -------------------

    onChangeValue = (e, target) => {
        const { form } = this.state;
        form[target] = e.target.value;
        this.setState({ form });
    };

    onChangeCheckboxValue = (target) => {
        const { form } = this.state;
        form[target] = !form[target];
        this.setState({ form });
    };

    onChangeRadio = (target, value) => {
        const { form } = this.state;
        form[target] = value;
        this.setState({ form });
    };

    onChangeSelectValue = (value, target) => {
        const { form } = this.state;

        if (target.includes(".")) {
            this.setNestedValue(form, target, value);
        } else {
            form[target] = value;
        }

        this.setState({ form });
    };

    onSelectImage = (imageId) => {
        const { form } = this.state;
        form.imageId = imageId;
        this.setState({ form });
    };

    onAddImage = (imageId) => {
        const { form } = this.state;
        form.imageId = imageId;
        this.setState({ form }, this.onSelectData);
    };

    onChangeZonesValue = (zonesConfig) => {
        const { form } = this.state;
        form.zonesConfig = zonesConfig;
        this.setState({ form });
    };

    // --------------------

    onFinishSelectData = () => {
        const { form } = this.state;

        const {
            showOnlyInSpineStops,
            hideNonInSpineStops,
            hidePreviousStops,
            hideZoneLimitStops,
            hideStopsWithMapPoint,
            shrinkText,
            showStopCode,
            stopCodePrecendentText,
            stopCodeSubsequentText,
            showDurations,
            durationBackgroundBuilderComponent,
            imageOrientation,
            imageId,
            showInterfacesInSpine,
            interfaceOption,
            interfaceRotationAngle,
            interfaceResizeFactor,
            showPathsDescription,
            addSpacerStops,
            highlightComplementaryTerminals,
            stretchSpine,
            showDescriptionOutsideSpine,
            descriptionOutsideSpine
        } = form;

        const stopsListConfiguration = {
            showOnlyInSpineStops,
            hideNonInSpineStops,
            hidePreviousStops,
            hideZoneLimitStops,
            hideStopsWithMapPoint,
            shrinkText,
            showStopCode,
            stopCodePrecendentText,
            stopCodeSubsequentText,
            showDurations,
            durationBackgroundBuilderComponent,
            imageOrientation,
            imageId,
            showInterfacesInSpine,
            interfaceOption,
            interfaceRotationAngle,
            interfaceResizeFactor,
            showPathsDescription,
            addSpacerStops,
            highlightComplementaryTerminals,
            stretchSpine,
            showDescriptionOutsideSpine,
            descriptionOutsideSpine
        };

        const stopsListStr = JSON.stringify(stopsListConfiguration);
        const zonesConfigStr = JSON.stringify({ zonesConfig: form.zonesConfig });

        this.props.onSelectData(`${form.textRotationAngle}|%|${stopsListStr}`, true);
        this.props.onConfigureData(zonesConfigStr, true);
    };

    // --------------------

    render() {
        const { configuration } = this.props;
        const { form } = this.state;

        return (
            <Form>
                <StopsListDataIdentifierCommonForm
                    form={form}
                    configuration={configuration}
                    selectedData={form.imageId}
                    onChangeValue={this.onChangeValue}
                    onChangeCheckboxValue={this.onChangeCheckboxValue}
                    onChangeSelectValue={this.onChangeSelectValue}
                    onChangeRadio={this.onChangeRadio}
                    onSelectImage={this.onSelectImage}
                    onAddImage={this.onAddImage}
                    onChangeZonesValue={this.onChangeZonesValue}
                    onFinishSelectData={this.onFinishSelectData}
                    onCancel={this.props.onCancel}
                />
            </Form>
        );
    }
}
